import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

export const LoadingSidePanelSection = () => {
  return <div css={loadingSectionStyles}></div>;
};

const loadingSectionStyles = css({
  height: '180px',
  width: '100%',
  background: token('color.background.accent.gray.subtlest'),
  borderRadius: '8px',
});
